import React, { useState } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import PropTypes from 'prop-types';
import DialogWithContent from '../../../components/common/DialogWithContent/DialogWithContent';
import TextArea from '../../../components/common/TextArea';
import { Typography } from '@mui/material';

function TranscriptionData(props) {
    const {
        transcriptionData,
        allowEdits,
        rowId,
        updateTranscriptionTextForRow,
    } = props;
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [transcriptionTextToEdit, setTranscriptionTextToEdit] = useState({});
    //const [editedTransText, setEditedTransText] = useState('');

    const updateTranscriptionText = (e) => {
        //add code here
        //debugger;
        setTranscriptionTextToEdit({
            ...transcriptionTextToEdit,
            text: e.target.value,
        });
    };

    const editTranscriptionText = (index, txt) => {
        let temp = txt.split('-');
        setTranscriptionTextToEdit({
            index: index,
            speaker: temp[0].trim(),
            text: temp[1].trim(),
        });
        setOpenEditDialog(true);
    };

    const saveEditedTranscriptionText = () => {
        //debugger;
        let tempData = JSON.parse(JSON.stringify(transcriptionData));

        tempData[transcriptionTextToEdit.index] =
            transcriptionTextToEdit.speaker +
            ' - ' +
            transcriptionTextToEdit.text;
        updateTranscriptionTextForRow(rowId, tempData);
        setOpenEditDialog(false);
    };

    return (
        <>
            <DialogWithContent
                open={openEditDialog}
                dialogTitle={`Edit Transcription text`}
                setOpen={setOpenEditDialog}
                //defaultValue={transcriptionTextToEdit}
                handleSave={saveEditedTranscriptionText}
            >
                {/* <Textarea 
                    aria-label="minimum height"
                    minRows={3}
                    placeholder={transcriptionTextToEdit}
                    defaultValue={transcriptionTextToEdit}
                    onChange={(e) => saveEditedTranscriptionText(e)}
                    style={{ width: '100%', padding: '10px' }}
                /> */}
                <Typography variant="h6">
                    {transcriptionTextToEdit.speaker}
                </Typography>
                <TextArea
                    value={transcriptionTextToEdit.text}
                    style={{ width: '100%', padding: '10px' }}
                    onChange={updateTranscriptionText}
                ></TextArea>
            </DialogWithContent>
            <div
                style={{
                    width: '100%',
                    padding: '10px',
                    textAlign: 'left',
                    whiteSpace: 'pre-wrap',
                    maxHeight: '99%',
                    overflowY: 'auto',
                    display: 'block',
                }}
            >
                {transcriptionData.map((line, index) => (
                    <div
                        key={index}
                        style={{
                            paddingBottom: '10px',
                            display: 'flex',
                            alignItems: 'start',
                        }}
                    >
                        {line.split('-').map((part, i) => (
                            <span
                                key={i}
                                style={{
                                    fontWeight: i === 0 ? 'bold' : 'normal',
                                    width: i === 0 ? '22%' : '78%',
                                }}
                            >
                                {part}
                                {i === 0 && '-'}
                            </span>
                        ))}
                        {allowEdits && (
                            <EditIcon
                                style={{
                                    fontSize: 'medium',
                                    marginLeft: '5px',
                                    color: '#000000',
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    // Handle edit icon click
                                    console.log('Edit icon clicked for:', line);
                                    editTranscriptionText(index, line);
                                }}
                            />
                        )}
                    </div>
                ))}
            </div>
        </>
    );
}

TranscriptionData.propTypes = {
    transcriptionData: PropTypes.arrayOf(PropTypes.string).isRequired,
    allowEdits: PropTypes.bool,
};

export default TranscriptionData;
